import { ChatPlacementPosition } from '@form-factory/schema/enums';
import { useLingui } from '@lingui/react/macro';
import { memo } from 'react';

import { Card } from '@/components/card/Card';
import { optionsFromEnum } from '@/components/form/formUtils';
import { SchemaFields } from '@/components/form/SchemaFields';
import { useFieldsSchema } from '@/components/form/useFieldsSchema';
import { useEnumTranslations } from '@/hooks';

export const ChatPlacementFields = memo(function ChatPlacementFields() {
  const { t } = useLingui();
  const enumTranslations = useEnumTranslations();

  const { schema: detailsSchema } = useFieldsSchema([
    {
      name: 'chatbotConfig.placement.position',
      label: t`Position`,
      type: 'select',
      options: optionsFromEnum(
        ChatPlacementPosition,
        key => enumTranslations.chatPlacementPosition[key],
      ),
      defaultValue: ChatPlacementPosition.Right,
      showOptional: false,
    },
    {
      name: 'chatbotConfig.placement.offsetX',
      type: 'number',
      label: t`Offset X`,
      defaultValue: 0,
      showOptional: false,
      uiProps: {
        addonAfter: 'px',
      },
    },
    {
      name: 'chatbotConfig.placement.offsetY',
      type: 'number',
      label: t`Offset Y`,
      defaultValue: 0,
      showOptional: false,
      uiProps: {
        addonAfter: 'px',
      },
    },
  ]);

  return (
    <Card title={t`Placement`}>
      <SchemaFields schema={detailsSchema} />
    </Card>
  );
});
